const choices = {
    dependant: 'à charge',
    alternate_custody: 'garde alternée',
    outside_household: 'hors du foyer fiscal',
};

export default choices;
